export class JSONAPIError extends Error {
    constructor(message, value, pointer = []) {
        super(message);
        this.value = value;
        this.pointer = pointer;
    }
}
export class JSONAPIRequestError extends JSONAPIError {
    constructor() {
        super(...arguments);
        this.name = 'JSONAPIRequestError';
    }
}
export class JSONAPIResponseError extends JSONAPIError {
    constructor() {
        super(...arguments);
        this.name = 'JSONAPIResponseError';
    }
}
export class JSONAPIValidationError extends JSONAPIError {
    constructor() {
        super(...arguments);
        this.name = 'JSONAPIValidationError';
    }
}
//# sourceMappingURL=Error.js.map